import React from 'react'
import moment from 'moment'

const timeFromNow = timeStamp => (
  <div style={{ textAlign: 'center' }}>
    <span style={{ color: 'rgba(208, 62, 62, 1)' }}>{moment(timeStamp).fromNow()}</span>
    <br />
    {moment(timeStamp).format('HH:mm a')}
    <br />
    {moment(timeStamp).format('DD-MMM-YYYY')}
    <br />
  </div>
)

export default timeFromNow



// WEBPACK FOOTER //
// ./src/containers/reports/components/TimeFromNow.js